import { clearLicenseSession } from '@alchemiesolns/product-registration';
import { signOut } from '@alchemiesolns/user-access';

/**
 * Signs out of Firebase Auth (via @alchemiesolns/user-access) and clears the
 * local license session held by @alchemiesolns/product-registration.
 *
 * Clears the license session before awaiting Firebase sign-out so we never get
 * `isAuthenticated() && !user` on `/login` (AuthPage shows a loading spinner for
 * that pair). Firebase can emit `user === null` before `signOut()` resolves.
 */
export async function signOutApp(): Promise<void> {
  clearLicenseSession();
  try {
    await signOut();
  } catch (e) {
    console.warn('[Auth] Sign-out failed:', e instanceof Error ? e.message : String(e));
  }
}
